export default __webpack_public_path__ + "static/media/spin-bg-11.d71c0be5.png";